module.exports = __webpack_public_path__ + "static/how-to-be-a-woman-044887343ddb9125c61fda78a1877d07.jpg";